import { Avatar, Button, Flex, Layout, Tag, Typography } from "antd"
import { useLocation, useNavigate } from "react-router-dom"

import Icon from "../../../../Icon"
import Images from "../../../../Images"
import { createAccountStepPath, onboardingStepPath } from "../../../../Utils/utils"
import OnboardingDots from "../OnboardingDots"

import "../../styles.less"

const { Header } = Layout
const { Title } = Typography

const OnboardingHeader = ({ isMobile }) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const isNewBusiness = pathname?.includes("/create-account")

  const handleNavigate = () => {
    if (isNewBusiness) {
      navigate(createAccountStepPath[7])
      return
    }
    navigate(onboardingStepPath[2])
  }

  return (
    <Header className="ob-header">
      <div className="ob-header__left">
        <div className="ob-logo">
          <Icon className="ob-logo__mark" type="logo" />
          <Title level={3} className="ob-logo__text">
            Chargeback
          </Title>
        </div>

        <Tag className="ob-badge">
          <Flex align="center" gap={4}>
            <div className="card-icons">
              <Avatar className="card-icons__visa" src={Images.visa} />
              <Avatar className="card-icons__mc" src={Images.mastercard} />
            </div>
            <div className="ob-badge__text">Official Visa and Mastercard partners</div>
          </Flex>
        </Tag>
      </div>

      {isMobile ? null : (
        <div className="ob-header__center">
          <OnboardingDots />
        </div>
      )}

      {isMobile ? null : (
        <div className="ob-header__right">
          <Button type="default" onClick={handleNavigate}>
            Save for later
          </Button>
        </div>
      )}
    </Header>
  )
}

export default OnboardingHeader
